import { parseDateToLocal } from 'shared/lib/dateFormatter';

/** Material UI */
import { Typography } from '@mui/material';

/** Internal Components */
import { customized_style } from 'shared/config/Styles';

/** Columns for the main grid displaying duty records. */
export const getEntryColumns = () => [
    {
        field: 'id',
        headerName: 'ID',
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'entry_week',
        headerName: 'Entry Week',
        align: 'center',
        headerAlign: 'center',
        flex: 0.4,
        renderCell: (params) => {
            const summaries = params.row?.il_jinro_summary ?? [];
            const weeks = summaries.map((item) => item.entry_week).filter(Boolean);
            const uniqueWeeks = [...new Set(weeks)];
            const display = uniqueWeeks.length ? uniqueWeeks.join(', ') : '';
            return <Typography sx={customized_style.itemDatagrid_Typography}>{display}</Typography>;
        },
    },
    {
        field: 'import_date',
        headerName: 'Import Date',
        align: 'center',
        headerAlign: 'center',
        flex: 0.4,
        editable: false,
        type: 'date',
        valueGetter: (params) => {
            return parseDateToLocal(params);
        },
        valueFormatter: (params) => {
            if (params) {
                const date = parseDateToLocal(params);
                if (date) {
                    return date.toLocaleDateString('en-US');
                }
            }
            return params;
        },
        renderCell: (params) => {
            if (params.value != null) {
                const date = parseDateToLocal(params.value);
                if (date) {
                    const formattedDate = date.toLocaleDateString('en-US', {
                        year: '2-digit',
                        month: '2-digit',
                        day: '2-digit',
                    });
                    return <Typography sx={customized_style.itemDatagrid_Typography}>{formattedDate}</Typography>;
                }
            }
            return null;
        },
    },
    {
        field: 'import_date_quarter',
        headerName: 'Quarter',
        align: 'center',
        headerAlign: 'center',
        flex: 0.4,
    },
    {
        field: 'opus_reference',
        headerName: 'Opus Ref',
        align: 'center',
        headerAlign: 'center',
        flex: 0.6,
    },
    {
        field: 'entry_number',
        headerName: 'Entry No.',
        align: 'center',
        headerAlign: 'center',
        flex: 0.6,
    },
    {
        field: 'contract_number',
        headerName: 'Contract No.',
        align: 'center',
        headerAlign: 'center',
        flex: 0.6,
    },
    {
        field: 'entry_fee',
        headerName: 'Entry Fee',
        align: 'center',
        headerAlign: 'center',
        flex: 0.4,
        type: 'number',
        valueFormatter: (params) => {
            const value = params ?? 0;
            return `$${Number(value).toFixed(2)}`;
        },
    },
    {
        field: 'trucking_fee',
        headerName: 'Trucking Fee',
        align: 'center',
        headerAlign: 'center',
        flex: 0.4,
        type: 'number',
        valueFormatter: (params) => {
            const value = params ?? 0;
            return `$${Number(value).toFixed(2)}`;
        },
    },
    {
        field: 'total_duty',
        headerName: 'Total Duty',
        align: 'center',
        headerAlign: 'center',
        flex: 0.4,
        type: 'number',
        valueFormatter: (params) => {
            const value = params ?? 0;
            return `$${Number(value).toFixed(2)}`;
        },
    },
    {
        field: 'refund_fee',
        headerName: 'Refund Fee',
        align: 'center',
        headerAlign: 'center',
        flex: 0.4,
        type: 'number',
        valueFormatter: (params) => {
            const value = params ?? 0;
            return `$${Number(value).toFixed(2)}`;
        },
    },
];

export const getTruckingColumns = () => [
    {
        field: 'id',
        headerName: 'ID',
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'trucking_week',
        headerName: 'Trucking Week',
        align: 'center',
        headerAlign: 'center',
        flex: 0.4,
        renderCell: (params) => {
            const summaries = params.row?.il_jinro_summary ?? [];
            const weeks = summaries.map((item) => item.trucking_week).filter(Boolean);
            const uniqueWeeks = [...new Set(weeks)];
            const display = uniqueWeeks.length ? uniqueWeeks.join(', ') : '';
            return <Typography sx={customized_style.itemDatagrid_Typography}>{display}</Typography>;
        },
    },
    {
        field: 'import_date',
        headerName: 'Import Date',
        align: 'center',
        headerAlign: 'center',
        flex: 0.4,
        editable: false,
        type: 'date',
        valueGetter: (params) => {
            return parseDateToLocal(params);
        },
        valueFormatter: (params) => {
            if (params) {
                const date = parseDateToLocal(params);
                if (date) {
                    return date.toLocaleDateString('en-US');
                }
            }
            return params;
        },
        renderCell: (params) => {
            if (params.value != null) {
                const date = parseDateToLocal(params.value);
                if (date) {
                    const formattedDate = date.toLocaleDateString('en-US', {
                        year: '2-digit',
                        month: '2-digit',
                        day: '2-digit',
                    });
                    return <Typography sx={customized_style.itemDatagrid_Typography}>{formattedDate}</Typography>;
                }
            }
            return null;
        },
    },
    {
        field: 'import_date_quarter',
        headerName: 'Quarter',
        align: 'center',
        headerAlign: 'center',
        flex: 0.4,
    },
    {
        field: 'opus_reference',
        headerName: 'Opus Ref',
        align: 'center',
        headerAlign: 'center',
        flex: 0.6,
    },
    {
        field: 'entry_number',
        headerName: 'Entry No.',
        align: 'center',
        headerAlign: 'center',
        flex: 0.6,
    },
    {
        field: 'contract_number',
        headerName: 'Contract No.',
        align: 'center',
        headerAlign: 'center',
        flex: 0.6,
    },
    {
        field: 'entry_fee',
        headerName: 'Entry Fee',
        align: 'center',
        headerAlign: 'center',
        flex: 0.4,
        type: 'number',
        valueFormatter: (params) => {
            const value = params ?? 0;
            return `$${Number(value).toFixed(2)}`;
        },
    },
    {
        field: 'trucking_fee',
        headerName: 'Trucking Fee',
        align: 'center',
        headerAlign: 'center',
        flex: 0.4,
        type: 'number',
        valueFormatter: (params) => {
            const value = params ?? 0;
            return `$${Number(value).toFixed(2)}`;
        },
    },
    {
        field: 'total_duty',
        headerName: 'Total Duty',
        align: 'center',
        headerAlign: 'center',
        flex: 0.4,
        type: 'number',
        valueFormatter: (params) => {
            const value = params ?? 0;
            return `$${Number(value).toFixed(2)}`;
        },
    },
    {
        field: 'refund_fee',
        headerName: 'Refund Fee',
        align: 'center',
        headerAlign: 'center',
        flex: 0.4,
        type: 'number',
        valueFormatter: (params) => {
            const value = params ?? 0;
            return `$${Number(value).toFixed(2)}`;
        },
    },
];

export const getEntryFeeColumns = () => [
    {
        field: 'id',
        headerName: 'ID',
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'account_no',
        headerName: 'Account Number',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
        valueGetter: () => {
            return '2.10905.07';
        },
    },
    {
        field: 'account_description',
        headerName: 'Account Description',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
    },
    {
        field: 'entry_amount',
        headerName: 'Amount',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
        cellClassName: (params) =>
            params.row.entry_amount_rounding_adjusted === true ? 'jinro-entry-amount-rounding-adjusted' : '',
        renderCell: (params) => (
            <Typography sx={{ ...customized_style.itemDatagrid_Typography, fontSize: '11px' }}>
                {params.value != null && !Number.isNaN(Number(params.value)) ? Number(params.value).toFixed(2) : ''}
            </Typography>
        ),
    },
    {
        field: 'item_code',
        headerName: 'Explanation',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
    },
    {
        field: 'coo',
        headerName: 'Co',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
    },
    {
        field: 'subtype',
        headerName: 'Sub type',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
        valueGetter: () => {
            return 'S';
        },
    },
    {
        field: 'subledger',
        headerName: 'Sub-Ledger',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
        renderCell: (params) => (
            <Typography sx={{ ...customized_style.itemDatagrid_Typography, fontSize: '11px' }}>
                {params.value ?? '-'}
            </Typography>
        ),
    },
];

export const getDutyTaxColumns = () => [
    {
        field: 'id',
        headerName: 'ID',
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'account_no',
        headerName: 'Account Number',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
        valueGetter: () => {
            return '2.10905.01';
        },
    },
    {
        field: 'account_description',
        headerName: 'Account Description',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
    },
    {
        field: 'duty_tax_amount',
        headerName: 'Amount',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
        renderCell: (params) => (
            <Typography sx={{ ...customized_style.itemDatagrid_Typography, fontSize: '11px' }}>
                {params.value != null && !Number.isNaN(Number(params.value)) ? Number(params.value).toFixed(2) : ''}
            </Typography>
        ),
    },
    {
        field: 'item_code',
        headerName: 'Explanation',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
    },
    {
        field: 'coo',
        headerName: 'Co',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
    },
    {
        field: 'subtype',
        headerName: 'Sub type',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
        valueGetter: () => {
            return 'S';
        },
    },
    {
        field: 'subledger',
        headerName: 'Sub-Ledger',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
        renderCell: (params) => (
            <Typography sx={{ ...customized_style.itemDatagrid_Typography, fontSize: '11px' }}>
                {params.value ?? '-'}
            </Typography>
        ),
    },
];

export const getDutyRefundColumns = () => [
    {
        field: 'id',
        headerName: 'ID',
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'account_no',
        headerName: 'Account Number',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
        valueGetter: (value, row) => (row?.id === '__refund_fee_line__' ? '2.10501.11' : '2.10905.01'),
    },
    {
        field: 'duty_refund_debit_amount',
        headerName: 'Debit Amount',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
        renderCell: (params) => (
            <Typography sx={{ ...customized_style.itemDatagrid_Typography, fontSize: '11px' }}>
                {params.value != null && !Number.isNaN(Number(params.value)) ? Number(params.value).toFixed(2) : ''}
            </Typography>
        ),
    },
    {
        field: 'duty_refund_credit_amount',
        headerName: 'Credit Amount',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
        cellClassName: (params) =>
            params.row.duty_refund_credit_amount_rounding_adjusted === true
                ? 'jinro-refund-credit-amount-rounding-adjusted'
                : '',
        renderCell: (params) => (
            <Typography sx={{ ...customized_style.itemDatagrid_Typography, fontSize: '11px' }}>
                {params.value != null && !Number.isNaN(Number(params.value)) ? Number(params.value).toFixed(2) : ''}
            </Typography>
        ),
    },
    {
        field: 'acclount_description',
        headerName: 'Account Description',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
    },

    {
        field: 'subtype',
        headerName: 'Sub type',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
        valueGetter: () => {
            return 'S';
        },
    },
    {
        field: 'subledger',
        headerName: 'Sub-Ledger',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
        renderCell: (params) => (
            <Typography sx={{ ...customized_style.itemDatagrid_Typography, fontSize: '11px' }}>
                {params.value ?? '-'}
            </Typography>
        ),
    },
    {
        field: 'subledger_description',
        headerName: 'Subledger Description',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
    },
    {
        field: 'item_code',
        headerName: 'Explanation',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
    },
];

export const getTruckingFeeColumns = () => [
    {
        field: 'id',
        headerName: 'ID',
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'account_no',
        headerName: 'Account Number',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
        valueGetter: () => {
            return '2.10905.07';
        },
    },
    {
        field: 'account_description',
        headerName: 'Account Description',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
    },
    {
        field: 'trucking_amount',
        headerName: 'Amount',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
        cellClassName: (params) =>
            params.row.trucking_amount_rounding_adjusted === true ? 'jinro-trucking-amount-rounding-adjusted' : '',
        renderCell: (params) => (
            <Typography sx={{ ...customized_style.itemDatagrid_Typography, fontSize: '11px' }}>
                {params.value != null && !Number.isNaN(Number(params.value)) ? Number(params.value).toFixed(2) : ''}
            </Typography>
        ),
    },
    {
        field: 'item_code',
        headerName: 'Explanation',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
    },
    {
        field: 'coo',
        headerName: 'Co',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
    },
    {
        field: 'subtype',
        headerName: 'Sub type',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
        valueGetter: () => {
            return 'S';
        },
    },
    {
        field: 'subledger',
        headerName: 'Sub-Ledger',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
        renderCell: (params) => (
            <Typography sx={{ ...customized_style.itemDatagrid_Typography, fontSize: '11px' }}>
                {params.value ?? '-'}
            </Typography>
        ),
    },
];
